import Vue from "vue";
import DateTimePicker from "vuetify-datetime-picker";
import { VueMasonryPlugin } from "vue-masonry";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import snackbarPlugin from "./plugins/snackbar";
import { auth } from "./firebase";

Vue.config.productionTip = false;
Vue.use(snackbarPlugin, { store });
Vue.use(DateTimePicker);
Vue.use(VueMasonryPlugin);

let app;
//eslint-disable-next-line
auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      store,
      router,
      vuetify,
      render: h => h(App)
    }).$mount("#app");
  }

  if (user) {
    store.dispatch("user/setUser", user);
  } else {
    localStorage.removeItem("role");
    localStorage.removeItem("token");
  }
});
